import styled from "styled-components";

export const Container = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;

  position: relative;
  flex: 1;
`;

export const Cards = styled.div`
  flex: 1;

  padding-bottom: 65px;
  padding-top: 15px;
  padding-right: 5px;

  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr;

  max-height: calc(100vh - 276px);
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  transition: 0.4s;

  /* width */
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: rgba(136, 136, 136, 0.25);
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.colors.primary};
  }
`;

export const Card = styled.div`
  background-color: #ffffff;

  height: 70px
  max-height: 100px

  border-left: 2px solid ${props => props.status};
  padding: 15px;

  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 7px 1px;

  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  transition: 0.4s;

  border-radius: 6px;

  cursor: pointer;

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.05) 0px 18px 29px 1px;
    z-index: 2;
  }
`;

export const Balance = styled.div`
  background-color: transparent;

  border-left: 2px solid ${props => props.status};
  padding: 15px;
  margin-top: 15px;

  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 7px 1px;

  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  transition: 0.4s;

  border-radius: 6px;
`;

export const Title = styled.h2`
  text-align: center
  font-family: "AvenirLTStd-Book";
  font-size: 16px;
  line-height: 21px;
  width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${props => props.theme.colors.primary};

  flex: 1;
`;

export const Subtitle = styled.span`
  font-family: "AvenirLTStd-Book";
  font-size: 14px;
  line-height: 14px;
  color: #707070;

  margin-right: 135px;
`;

export const Comment = styled.span`
  font-family: "AvenirLTStd-Book";
  font-size: 12px;
  line-height: 12px;
  color: #707070;

  margin-right: 15px;
`;

export const Icon = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
`;

export const AddButton = styled.button`
  box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 15px 1px;
  position: absolute;
  right: 0px;
  bottom: 80px;

  border: 0;
  border-radius: 10px;
  background: #ffffff;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  padding: 15px;

  font-family: "AvenirLTStd-Book";
  font-size: 13px;
  line-height: 19px;
  color: #707070;
  text-transform: uppercase;

  cursor: pointer;

  z-index: 3;

  svg {
    transition: 0.4s;
    margin-right: 11px;
  }

  transition: 0.4s;

  &:hover {
    svg {
      margin-right: 20px;
    }
  }
`;

export const FormModal = styled.form`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const ImagesGrid = styled.div`
  flex: 1;

  padding-top: 15px;

  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
`;

export const ImageUploadContainer = styled.div`
  width: 510px;
  margin: 0 auto;
  display: flex;
  align-content: center;
  justify-content: center;
  
`;
